import React from "react";
import {Input} from 'reactstrap'

// listing country code component 

const SelectCountry = (props) => {
  const {  getCountryCode,tab, name, onChange, value, onKeyPress,widthValue } = props;
console.log(getCountryCode)
  
  return (
    <div>
      <Input
        tabIndex={tab}
       type="select"
        onChange={onChange}
        style={{ height: "50px", marginTop: "0.6rem", width: `${widthValue}` }}
        onKeyPress={onKeyPress}
        name={name}
        id={name}
        value={value}
      >
           <option>+91</option>
        {  getCountryCode.length > 0 &&  getCountryCode.map((option) => {
          return (
         
            <option key={option.dialingCode} value={option.dialingCode}>
              +{option.dialingCode}
            </option>
          );
        })}
      </Input>
    </div>
  );
};

export default SelectCountry;
